import { render, staticRenderFns } from "./MemorialForm.vue?vue&type=template&id=f8ecc1f0&scoped=true&"
import script from "./MemorialForm.vue?vue&type=script&lang=js&"
export * from "./MemorialForm.vue?vue&type=script&lang=js&"
import style0 from "./MemorialForm.vue?vue&type=style&index=0&id=f8ecc1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ecc1f0",
  null
  
)

export default component.exports